import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-donorfy',
  name: 'Access Donorfy',
  category: 'access-integrations',
  description: 'Donorfy CRM integration for fundraising and donor management',
  icon: 'Heart',
  color: 'orange',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  credentials: [
    {
      name: 'donorfy',
      required: true,
    },
  ],
  tags: ['access', 'donorfy', 'crm', 'fundraising', 'donations'],
};

export default definition;
